import { Controller } from "@hotwired/stimulus"

// Mobile hamburger for the site header: below 768px the nav links collapse
// into a panel this controller toggles. Desktop never shows the button.
export default class extends Controller {
  static targets = ["button"]

  declare readonly buttonTarget: HTMLButtonElement

  private keyHandler = (event: KeyboardEvent): void => {
    if (event.key === "Escape") this.close()
  }

  connect(): void {
    document.addEventListener("keydown", this.keyHandler)
  }

  disconnect(): void {
    document.removeEventListener("keydown", this.keyHandler)
  }

  toggle(): void {
    const open = this.element.classList.toggle("main-nav--open")
    this.syncButton(open)
  }

  close(): void {
    this.element.classList.remove("main-nav--open")
    this.syncButton(false)
  }

  private syncButton(open: boolean): void {
    this.buttonTarget.setAttribute("aria-expanded", String(open))
    this.buttonTarget.setAttribute("aria-label", open ? "Close menu" : "Open menu")
  }
}
